import DateFnsUtils from "@date-io/date-fns";

type colorType = "primary" | "secondary";

export const EVENT_SHIFT_STATUS = {
  Initial: 0,
  Started: 1,
  EnRouteToSite: 2,
  OnSite: 3,
  EventComplete: 4,
  EnRouteBack: 5,
  ArrivedBack: 6,
  Cancelled: 7,
};

export interface Location {
  text: string;
  value: string;
}

export interface StartLocation {
  id: string | null;
  name: string | null;
}

export interface CustomStartLocation {
  eventLocationGooglePlaceId: string | null;
  eventLocationLatitude: string | null;
  eventLocationLongitude: string | null;
}

export interface ReturnLocation {
  returnLocation: string | null;
  returnLocationGooglePlaceId: string | null;
  returnLocationLatitude: string | null;
  returnLocationLongitude: string | null;
}

export const OTHER_LOCATION: Location = {
  text: "Other Location",
  value: "other-location",
};

export const timeString = (dateTime: any): string => {
  if (!dateTime || dateTime == "") {
    return "";
  }
  const dateUtils = new DateFnsUtils();
  const hrs = dateUtils.getHours(dateTime);
  const mins = dateUtils.getMinutes(dateTime);

  return `${hrs < 10 ? "0" : ""}${hrs}:${mins < 10 ? "0" : ""}${mins}`;
};

export const ROUTE_STATES = {
  EN_ROUTE_TO_SITE: {
    button1: {
      disabled: false,
      color: "primary" as colorType,
    },
    button2: {
      disabled: false,
      color: "secondary" as colorType,
    },
    button3: {
      disabled: true,
      color: "secondary" as colorType,
    },
    button4: {
      disabled: true,
      color: "secondary" as colorType,
    },
    button5: {
      disabled: true,
      color: "secondary" as colorType,
    },
  },
  ON_SITE: {
    button1: {
      disabled: true,
      color: "primary" as colorType,
    },
    button2: {
      disabled: false,
      color: "primary" as colorType,
    },
    button3: {
      disabled: false,
      color: "secondary" as colorType,
    },
    button4: {
      disabled: true,
      color: "secondary" as colorType,
    },
    button5: {
      disabled: true,
      color: "secondary" as colorType,
    },
  },
  EVENT_COMPLETE: {
    button1: {
      disabled: true,
      color: "primary" as colorType,
    },
    button2: {
      disabled: true,
      color: "primary" as colorType,
    },
    button3: {
      disabled: false,
      color: "primary" as colorType,
    },
    button4: {
      disabled: false,
      color: "secondary" as colorType,
    },
    button5: {
      disabled: true,
      color: "secondary" as colorType,
    },
  },
  EN_ROUTE_BACK: {
    button1: {
      disabled: true,
      color: "primary" as colorType,
    },
    button2: {
      disabled: true,
      color: "primary" as colorType,
    },
    button3: {
      disabled: true,
      color: "primary" as colorType,
    },
    button4: {
      disabled: false,
      color: "primary" as colorType,
    },
    button5: {
      disabled: false,
      color: "secondary" as colorType,
    },
  },
  ARRIVED_BACK: {
    button1: {
      disabled: true,
      color: "primary" as colorType,
    },
    button2: {
      disabled: true,
      color: "primary" as colorType,
    },
    button3: {
      disabled: true,
      color: "primary" as colorType,
    },
    button4: {
      disabled: true,
      color: "primary" as colorType,
    },
    button5: {
      disabled: false,
      color: "primary" as colorType,
    },
  },
};
